// import { Tooltip } from "@fluentui/react-components";
import React from "react";
import { IResourceProps } from "./Models";
import {
  HeaderResourcesLeft2Wrapper,
  HeaderResourcesLeftWrapper,
  HeaderResourcesNameWrapper,
  HeaderResourcesRight2Wrapper,
  HeaderResourcesRightWrapper,
  HeaderResourcesSection2Wrapper,
  HeaderResourcesSectionWrapper,
  SectionResourcesWrapper,
} from "./Styles";
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import ScrollDismissTooltip from "../Tooltip";

const ResourceItem = (props: IResourceProps) => {
  return (
    <SectionResourcesWrapper
      className="SectionResourcesWrapper"
      $isSelected={props.isSelected}
      $theme={props.theme}
      style={{
        ...props.leftBorderStyle,
        minHeight: "45px",
      }}
      {...BuildRCAttribute(`resource_item.${props.name}.${props.isSelected}`)}
    >
      <HeaderResourcesSectionWrapper className="HeaderResourcesSectionWrapper">
        <HeaderResourcesLeftWrapper className="HeaderResourcesLeftWrapper">
           <ScrollDismissTooltip  content={props.name || ""} relationship="label">
            <HeaderResourcesNameWrapper className="HeaderResourcesNameWrapper">
              <div className="label-text">{props.name}</div>
            </HeaderResourcesNameWrapper>
          </ScrollDismissTooltip>
        </HeaderResourcesLeftWrapper>
        <HeaderResourcesRightWrapper className="HeaderResourcesRightWrapper">
          {props.iconPermission}
          {props.headerButtons}
        </HeaderResourcesRightWrapper>
      </HeaderResourcesSectionWrapper>
      {!props.isSelected && !props.isShowTimeLine && props.availabilityBox ? (
        <>
          <HeaderResourcesLeft2Wrapper
            className="HeaderResourcesLeft2Wrapper"
            $isSelected={props.isSelected}
          >
            {props.content}
          </HeaderResourcesLeft2Wrapper>
          <HeaderResourcesSection2Wrapper className="HeaderResourcesSection2Wrapper mt_0 custom_display_availabilityBox">
            <HeaderResourcesRight2Wrapper className="HeaderResourcesRight2Wrapper">
              {props.availabilityBox}
            </HeaderResourcesRight2Wrapper>
          </HeaderResourcesSection2Wrapper>
        </>
      ) : (
        <>
          <HeaderResourcesSection2Wrapper className="HeaderResourcesSection2Wrapper">
            <HeaderResourcesLeft2Wrapper
              className="HeaderResourcesLeft2Wrapper"
              $isSelected={props.isSelected}
            >
              {props.content}
            </HeaderResourcesLeft2Wrapper>

            <HeaderResourcesRight2Wrapper className="HeaderResourcesRight2Wrapper">
              {props.isSelected ? (
                props.buttonOrderFormElement
              ) : (
                <React.Fragment>
                  {!props.isShowTimeLine && props.availabilityBox}
                </React.Fragment>
              )}
            </HeaderResourcesRight2Wrapper>
          </HeaderResourcesSection2Wrapper>
          {props.isShowTimeLine && props.timeLineElements}
          {props.isSelected && (
            <React.Fragment>
              {!props.isShowTimeLine && props.availabilityBox ? (
                <HeaderResourcesSection2Wrapper className="HeaderResourcesSection2Wrapper mt_0 custom_display_availabilityBox">
                  <HeaderResourcesRight2Wrapper className="HeaderResourcesRight2Wrapper">
                    {props.availabilityBox}
                  </HeaderResourcesRight2Wrapper>
                </HeaderResourcesSection2Wrapper>
              ) : null}
            </React.Fragment>
          )}
        </>
      )}
    </SectionResourcesWrapper>
  );
};

export default ResourceItem;
